import React from "react";
import NavBar from "./NavBar";
import UserMenu from "./UserMenu";
import { connect } from "react-redux";
import { logoutUser } from "../../redux/Actions/authAction";
import SidebarV2 from "./Sidebar/SidebarV2";

function Container(props) {
  let getCollapse = localStorage.getItem("collapse") == "true" ? "toggled" : "";
  return (
    <>
      <div id="custom_modal"></div>
      <div className={`d-flex ${getCollapse}`} id="wrapper">
        <SidebarV2 location={props.location} auth={props.auth} />
        <div id="page-content-wrapper">
          <NavBar
            goBack={props.goBack}
            location={props.location}
            breadcrumbs={props.breadcrumbs}
            logout={() => props.logoutUser()}
            user={props.auth.user}
          />
          <div>{props.children}</div>
        </div>
        <UserMenu logout={() => props.logoutUser()} user={props.auth.user} />
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(Container);
